if (!customElements.get('rb-sleep-setup')) {
  customElements.define('rb-sleep-setup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form');
      this.variants = JSON.parse(this.querySelector('[data-setup-main]').textContent);
      this.format = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.fixedDiscount = Math.round(1000 * (this.dataset.currency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate || 1)));
      this.sync = this.update.bind(this);
      this.button = this.querySelector('.rb-sleep-setup__button');
      this.submitPillow = this.addSelection.bind(this);
      this.button.addEventListener('click', this.submitPillow);
      this.selectMain = () => {
        const variant = this.variants.find(item => String(item.id) === this.querySelector('[data-setup-main-card] [data-setup-variant]').value);
        if (!variant) return;
        this.form.querySelectorAll('[data-rbbb-color], [data-rbbb-option]').forEach(select => {
          const position = Number(select.dataset.optionPosition) - 1;
          select.value = variant.options[position];
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.update();
      };
      this.querySelector('[data-setup-main-card] [data-setup-variant]')?.addEventListener('change', this.selectMain);
      this.form.addEventListener('change', this.sync);
      this.form.addEventListener('input', this.sync);
      this.form.addEventListener('click', this.sync);
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.sync);
      this.form?.removeEventListener('input', this.sync);
      this.form?.removeEventListener('click', this.sync);
      this.button?.removeEventListener('click', this.submitPillow);
      this.querySelector('[data-setup-main-card] [data-setup-variant]')?.removeEventListener('change', this.selectMain);
      this.initialized = false;
    }
    money(cents) { return this.format.format(cents / 100); }
    async addSelection() {
      if (this.button.disabled || this.busy) return;
      const label = this.button.textContent;
      const error = this.querySelector('[data-setup-error]');
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.button.dataset.adding;
      error.hidden = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      try {
        const payload = { items: this.selectedItems };
        if (cart) {
          payload.sections = cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(this.button);
        }
        const addUrl = window.routes.cart_add_url.replace(/(?:\.js)?$/, '.js');
        const response = await fetch(addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || window.cartStrings?.error || 'Unable to add this selection.');
        if (!cart) { window.location.assign(window.routes.cart_url); return; }
        cart.classList.remove('is-empty');
        cart.renderContents(result);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-sleep-setup', cartData: result });
      } catch (failure) {
        error.textContent = failure.message;
        error.hidden = false;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.button.textContent = label;
        this.update();
      }
    }
    update() {
      const mainId = this.form.querySelector('[data-rbbb-variant-id]').value;
      const main = this.variants.find(variant => String(variant.id) === mainId);
      const quantity = Math.max(1, parseInt(this.form.querySelector('[name="quantity"]').value, 10) || 1);
      let subtotal = (main?.price || 0) * quantity;
      let regularSubtotal = Math.max(main?.compare_at_price || 0, main?.price || 0) * quantity;
      let count = quantity;
      let extraSaving = 0;
      const giftProperties = Object.fromEntries(Array.from(this.form.querySelectorAll('[data-rb-checkout-gift-property]'), input => [input.dataset.rbCheckoutGiftProperty, input.value]));
      this.selectedItems = [{ id: main?.id, quantity, properties: giftProperties }];
      this.querySelectorAll('[data-setup-card]').forEach(card => {
        const isMain = card.hasAttribute('data-setup-main-card');
        if (isMain && main) card.querySelector('[data-setup-variant]').value = String(main.id);
        const option = card.querySelector('[data-setup-variant]')?.selectedOptions[0];
        const price = Number(option?.dataset.price ?? card.dataset.price);
        const compare = Number(option?.dataset.compare ?? card.dataset.compare);
        const checked = isMain || card.querySelector('[data-setup-toggle]').checked;
        card.classList.toggle('is-selected', checked);
        const discountedPrice = !isMain && checked ? Math.max(0, price - this.fixedDiscount) : price;
        card.querySelector('[data-setup-price]').textContent = this.money(discountedPrice);
        card.querySelector('[data-setup-compare]').textContent = this.money(!isMain && checked ? price : compare);
        card.querySelector('[data-setup-compare]').hidden = !isMain && checked ? false : compare <= price;
        if (option?.dataset.image) {
          const image = card.querySelector('img');
          if (image.getAttribute('src') !== option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        }
        if (checked && !isMain) {
          subtotal += price * quantity;
          regularSubtotal += Math.max(compare, price) * quantity;
          count += quantity;
          extraSaving += Math.min(price, this.fixedDiscount) * quantity;
          this.selectedItems.push({ id: option?.value || card.dataset.variantId, quantity });
        }
      });
      const offer = this.querySelector('[data-setup-offer]');
      offer.hidden = this.selectedItems.length < 2;
      offer.textContent = (this.selectedItems.length > 1 ? offer.dataset.selected : offer.dataset.unselected).replace('[amount]', this.money(this.fixedDiscount));
      const condition = this.querySelector('[data-setup-condition]');
      condition.textContent = condition.dataset.template.replace('[amount]', this.money(this.fixedDiscount));
      const total = subtotal - extraSaving;
      const showSubtotal = this.classList.contains('rb-sleep-setup--subtotal');
      const saving = showSubtotal ? Math.max(0, regularSubtotal - total) : extraSaving;
      this.button.disabled = Boolean(this.busy) || !main?.available;
      if (!this.busy) this.button.textContent = this.selectedItems.length > 1 ? this.button.dataset.bundle : this.button.dataset.pillow;
      const countNode = this.querySelector('[data-setup-count]');
      countNode.textContent = this.selectedItems.length === 1 ? countNode.dataset.single : countNode.dataset.template.replace('[count]', count);
      this.querySelector('[data-setup-total]').textContent = this.money(total);
      const before = this.querySelector('[data-setup-before]');
      before.hidden = !saving;
      before.textContent = this.money(showSubtotal ? regularSubtotal : subtotal);
      const saved = this.querySelector('[data-setup-saving]');
      saved.hidden = !saving;
      const savingWrap = this.querySelector('[data-setup-saving-wrap]');
      if (savingWrap) savingWrap.hidden = !saving;
      saved.textContent = saved.dataset.template.replace('[amount]', this.money(saving));
    }
  });
}

